import React from "react"
import { Cell } from "fixed-data-table-2"
import moment from "moment"
import PropTypes from "prop-types"
import InputCell from "sheets/components/cells/InputCell"

export const TextDateCell = ({ rowId, columnId, children, cellIsEditable, sheetId, editing, ...props }) => {
    return (
        <Cell {...props}>
            {children
                ? (Number(children) ? moment.unix(children).local().format("DD MMM YYYY") : moment(children))
                      .local()
                      .format("DD MMM YYYY")
                : undefined}
        </Cell>
    )
}

const DateCell = ({ rowId, columnId, children, cellIsEditable, sheetId, editing, ...props }) => {
    if (editing && cellIsEditable) {
        return (
            <InputCell
                type="date"
                columnId={columnId}
                isResourceTable={props.isResourceTable}
                rowId={rowId}
                sheetId={sheetId}
                width={props.width}
                field={props.field}
            >
                {children
                    ? (Number(children) ? moment.unix(children) : moment(children)).local().format("L")
                    : undefined}
            </InputCell>
        )
    }
    return (
        <Cell {...props}>
            {children ? (Number(children) ? moment.unix(children) : moment(children)).local().format("L") : undefined}
        </Cell>
    )
}

DateCell.propTypes = {
    rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    columnId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    children: PropTypes.string,
    sheetId: PropTypes.string.isRequired,
    editing: PropTypes.bool,
    isResourceTable: PropTypes.bool,
    width: PropTypes.number,
    field: PropTypes.object.isRequired,
}

export default DateCell
